import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import Navbar from './Navbar';
import Footer from './Footer';
import WhatsAppFloat from './WhatsAppFloat';
import { NAV_LINKS, site } from '../data/site';

const PAGE_TITLES = {
  '/': site.siteNameFull,
  ...Object.fromEntries(NAV_LINKS.filter((l) => l.path !== '/').map((l) => [l.path, `${l.label} | Grupo Majo Engenharia`])),
  '/simulador': 'Simulador de Orçamento | Grupo Majo Engenharia',
};

export default function Layout({ children }) {
  const lenisRef = useRef(null);
  const { pathname } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    lenisRef.current?.scrollTo(0, { immediate: true });
    document.title = PAGE_TITLES[pathname] || site.siteNameFull;
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-[var(--bg)] text-[var(--text)]">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
